import { ACPage } from 'academy-navigation-lib/components/ACPage/ACPage';
import { useIsPartner } from '../../partners/partnersQueries';
import { useHasGate } from '../../accounts/accountsQueries';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
export const NavPage = ({
  children
}) => {
  const isPartner = useIsPartner();
  const {
    hasGate: isUngatedForUnifiedAcademyNavigation
  } = useHasGate('Academy:UnifiedAcademy:Navigation');
  if (!isUngatedForUnifiedAcademyNavigation) {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: children
    });
  }
  return /*#__PURE__*/_jsx(ACPage, {
    isPartner: !!isPartner,
    children: children
  });
};